import React, { useState } from 'react';
import './index.scss';
import Button from '../Button';

export default function NewsHotList({ category, onRefresh, list: propList }) {
  const [list, setList] = useState(propList || []);
  // 新增：用对象记录每条新闻图片是否加载失败
  const [imgErrorMap, setImgErrorMap] = useState({});

  React.useEffect(() => {
    if (propList) setList(propList);
    setImgErrorMap({}); // 切换数据时重置图片错误状态
  }, [propList]);

  const handleRefresh = () => {
    if (onRefresh) onRefresh();
  };

  const handleImgError = (id) => {
    setImgErrorMap(prev => ({ ...prev, [id]: true }));
  };

  return (
    <div className="news-hot-list">
      <div className="news-hot-list-header">
        <span className="news-hot-list-title">{category} · 热门资讯</span>
        <Button type="primary" size="small" onClick={handleRefresh}>
          刷新
        </Button>
      </div>
      <div className="news-hot-list-body">
        {list.length === 0 && <div style={{color:'#00ff99',margin:'24px auto',textAlign:'center'}}>暂无数据</div>}
        {Array.isArray(list) && list.map(item => (
          <div className="news-hot-list-item" key={item.id} onClick={() => item.url && window.open(item.url, '_blank')} style={{cursor: item.url ? 'pointer' : 'default'}}>
            {item.image && !imgErrorMap[item.id] ? (
              <img
                src={item.image}
                alt={item.title}
                className="news-hot-list-img"
                style={{width: 80, height: 60, objectFit: 'cover', borderRadius: 6, marginRight: 16}}
                onError={() => handleImgError(item.id)}
              />
            ) : (
              <div
                className="news-hot-list-fallback"
                style={{width: 80, height: 60, borderRadius: 6, marginRight: 16, background: '#e0e0e0', display: 'block'}}
              />
            )}
            <div className="news-hot-list-info">
              <div className="news-hot-list-title-row">{item.title}</div>
              <div className="news-hot-list-summary">{item.summary}</div>
              <div className="news-hot-list-meta">
                <span>{item.time}</span>
                <span className="news-hot-list-source">{item.source}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 